<script setup lang="ts">
import { useSettings } from "@/composables/shared/useSettings";
import { useEnvironmentStore } from "@/stores/environmentStore";
import { computed } from "vue";

defineProps<{
  compacted?: boolean;
}>();

const envStore = useEnvironmentStore();
const { isDarkMode } = useSettings();

const logoSrc = computed(() => {
  return isDarkMode.value ? "/logo_negative.svg" : "/logo_color.svg";
});
</script>

<template>
  <div class="tw:flex tw:items-center tw:gap-2">
    <v-hover>
      <template v-slot:default="{ isHovering, props: hoverProps }">
        <router-link
          to="/"
          class="tw:flex tw:w-[160px] tw:max-w-full tw:!pb-1"
          v-bind="hoverProps"
          data-testid="logo-link"
        >
          <img
            :src="logoSrc"
            :class="[
              'tw:min-h-4 tw:overflow-hidden tw:transition-fill tw:duration-250 tw:ease-in-out',
              {
                'tw:fill-primary': !isHovering,
                'tw:fill-secondary': isHovering,
              },
            ]"
          />
        </router-link>
      </template>
    </v-hover>
    <v-chip
      v-if="envStore.badge"
      :color="envStore.badge.gradient ? '' : envStore.badge.color"
      variant="flat"
      :rounded="false"
      size="small"
      :density="'compact'"
      :class="[
        'tw:text-white tw:leading-none tw:!rounded-md tw:!py-1 tw:md:!py-2 tw:!px-1 tw:md:!px-1.5 tw:!text-[.6rem] tw:self-center tw:transform-gpu tw:origin-left',
        envStore.badge.gradient,
      ]"
    >
      <span class="tw:text-white tw:leading-none tw:font-medium">
        {{ envStore.badge.label }}
      </span>
    </v-chip>
  </div>
</template>
